export enum RelayDefaultStateEnum {
    high = 0,
    low = 1
}
